import type { PageContext } from 'vike/types'

import { extractLocale } from '../utils/i18n'

const getPathName = (urlOrPathname: string) => {
  try {
    const url = new URL(urlOrPathname)
    return url.pathname
  } catch {
    return urlOrPathname
  }
}

export default function onCreatePageContext(pageContext: PageContext) {
  const { locale } = extractLocale(getPathName(pageContext.urlOriginal))

  pageContext.locale = locale
}
